import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { attendanceFlagsService } from "@data/services/attendanceFlagsService"
import { authService } from "@data/services/authService"
import { liveService } from "@data/services/liveService"
import { subscriptionService } from "@data/services/subscriptionService"

// ** Initial State
const initialState = {
    full_list: [],
    list: [],
    live_occurrences: [],
    makeupOccurrences: [],
    absenceLiveSession: null,
    hasSelection: false,
    selectedOccurrenceId: null,
    attendance_flags_to_be_recovered: [],
}

export function liveSessions(state = initialState, action) {
    switch (action.type) {
        // Reset on logout
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authConstants.SWITCH_ACCOUNT:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        case subscriptionService.getSubscribePricing.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                full_list: action?.data?.user?.live_sessions,
                list: action?.data?.user?.live_sessions,
            }

        case liveService.getAllMyNextLiveSessionsAsParent.name +
            apiConstants._SUCCESS:
        case liveService.getAllMyNextLiveSessions.name +
            apiConstants._SUCCESS: {
            const hasLiveRoom = action?.urlParams?.live_room_id !== undefined
            const listKey = hasLiveRoom ? "list" : "full_list"
            const live_occurrences = action?.data?.live_occurrences
            const live_sessions = action?.data?.live_sessions

            const shouldUpdateOccurrences =
                live_occurrences &&
                Array.isArray(live_occurrences) &&
                !hasLiveRoom

            const newState = {
                ...state,
                [listKey]: live_sessions,
                attendance_flags_to_be_recovered:
                    action?.data?.attendance_flags_to_be_recovered,
            }

            if (shouldUpdateOccurrences) {
                newState.live_occurrences = live_occurrences
            }

            return newState
        }
        // Un rattrapage posé retire son absence de la liste « à rattraper » dès la réponse : sans
        // ça, jusqu'au rechargement des séances, la ligne « Planifier » restait affichée et
        // rouvrait un parcours sur l'absence déjà rattrapée — que le serveur accepte encore.
        case liveService.recoverAbsenceAsParent.name + apiConstants._SUCCESS:
        case liveService.recoverAbsenceAsStudent.name + apiConstants._SUCCESS: {
            const recoveredFlagId = Number(action?.routeParams?.id)
            return {
                ...state,
                attendance_flags_to_be_recovered: (
                    state.attendance_flags_to_be_recovered || []
                ).filter((flag) => Number(flag?.id) !== recoveredFlagId),
            }
        }
        case attendanceFlagsService.cancelAttendanceFlag.name +
            apiConstants._SUCCESS: {
            // Parse ID as number to ensure type consistency
            const canceledFlagId = Number(action?.routeParams?.id)
            let recoveryOccurrenceId = null

            // Search for the flag in all sessions to get its recovery_live_occurrence_id
            state.full_list?.forEach((session) => {
                const flag = session.attendance_flags?.find(
                    (f) => Number(f.id) === canceledFlagId
                )
                if (flag?.recovery_live_occurrence_id) {
                    recoveryOccurrenceId = flag.recovery_live_occurrence_id
                }
            })

            // Also search in live_occurrences (new data structure)
            if (!recoveryOccurrenceId) {
                state.live_occurrences?.forEach((occurrence) => {
                    const flag =
                        occurrence.live_session?.attendance_flags?.find(
                            (f) => Number(f.id) === canceledFlagId
                        )
                    if (flag?.recovery_live_occurrence_id) {
                        recoveryOccurrenceId = flag.recovery_live_occurrence_id
                    }
                })
            }

            return {
                ...state,
                list: state.list?.map((session) => ({
                    ...session,
                    attendance_flags: session.attendance_flags?.filter(
                        (flag) => Number(flag.id) !== canceledFlagId
                    ),
                })),
                full_list: state.full_list?.map((session) => ({
                    ...session,
                    attendance_flags: session.attendance_flags?.filter(
                        (flag) => Number(flag.id) !== canceledFlagId
                    ),
                })),
                live_occurrences: state.live_occurrences
                    ?.filter(
                        (occurrence) => occurrence.id !== recoveryOccurrenceId
                    )
                    ?.map((occurrence) => ({
                        ...occurrence,
                        live_session: {
                            ...occurrence.live_session,
                            attendance_flags:
                                occurrence.live_session?.attendance_flags?.filter(
                                    (flag) => Number(flag.id) !== canceledFlagId
                                ),
                        },
                    })),
            }
        }
        case liveService.reportAbsenceAsParent.name + apiConstants._SUCCESS:
        case liveService.reportAbsenceAsStudent.name + apiConstants._SUCCESS:
            return {
                ...state,
                list: state.list.map((session) => ({
                    ...session,
                    attendance_flags:
                        action.data?.id === session?.id
                            ? action.data?.attendance_flags
                            : session?.attendance_flags,
                })),
                full_list: state.full_list.map((session) => ({
                    ...session,
                    attendance_flags:
                        action.data?.id === session?.id
                            ? action.data?.attendance_flags
                            : session?.attendance_flags,
                })),
            }

        case liveService.getMakeupOccurrences.name + apiConstants._SUCCESS:
            return {
                ...state,
                makeupOccurrences: action.data.makeup_occurrences,
                absenceLiveSession: action.data.absence_live_session,
                hasSelection: action.data.has_selection,
                selectedOccurrenceId: action.data.selected_occurrence_id,
            }

        default:
            return state
    }
}

export default liveSessions
